/**
 * 팝업 결과
 */
export enum PopupResultType {
    INVALID,
    /** 확인(OK) 버튼 선택 */
    OK,
    /** 취소(Cancel) 버튼 선택 */
    CANCEL,
    /** 닫기(Close) 버튼 선택 */
    CLOSE,
  }
  
  export enum PopupIconType {
    NONE,
    /** 느낌표 */
    EXCLAMATION,
    /** 체크 */
    CHECK,
  }
  
  /** 팝업 버튼 속성 */
  export interface IPopupButton {
    /** 버튼 순서 */
    seq: number;
    /** 버튼 이름 */
    caption?: string;
    /** css 속성 */
    className?: string;
    /** 버튼 이벤트 */
    onClick?: VoidFunction;
  }
  
  /** 팝업 속성 */
  export interface IBasePopupProps {
    /** 팝업 제목 */
    title?: string;
    /** 팝업 메시지 */
    message: string;
    /** 팝업 아이콘 유형 */
    icon?: PopupIconType;
    /** 팝업 버튼 정의 */
    buttons: IPopupButton[];
    /** 닫기 버튼 정의 */
    onClose?: VoidFunction;
  }
  

  export enum PopupType {
    ALERT,
    CONFIRM,
  }



/**
 * 팝업 하단 버튼 타입
 */
export enum PopupDisplayBtnType {
  INVALID,
  /** 확인(OK) 버튼 표시 */
  OK,
  /** 선택(Select) 버튼 표시 */
  SELECT,
}


export interface BasePopupProps {
  id?: string;
  message?: string;
  icon?: PopupIconType;
  buttons: IPopupButton[];
  onClose?: VoidFunction;
}
